import React, { useEffect, useState, useRef } from 'react';
import { API_BASE } from '../config';
import AchievementBadge from './AchievementBadge';

export default function GuildPage({ slug }) {
  const [guild, setGuild] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ripped, setRipped] = useState(false);
  const parallaxRef = useRef(null);

  useEffect(() => {
    fetch(`${API_BASE}/guild/${slug}?t=${Date.now()}`)
      .then(r => r.ok ? r.json() : Promise.reject('Not found'))
      .then(data => { setGuild(data); setLoading(false); setTimeout(() => setRipped(true), 600); })
      .catch(() => { setError('Guild not found'); setLoading(false); });
  }, [slug]);

  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        parallaxRef.current.style.transform = `translateY(${window.pageYOffset * 0.4}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (loading) return <div className="guild-page"><div className="guild-loading">Loading...</div></div>;
  if (error) return <div className="guild-page"><div className="guild-error">{error}</div></div>;

  return (
    <div className="guild-page">
      {/* Rip intro overlay */}
      <div className={`rip-intro ${ripped ? 'ripped' : ''}`}>
        <div className="rip-intro-top" />
        <div className="rip-intro-bottom" />
      </div>
      {ripped && <div className="rip-embers" />}

      {/* Permanent frame */}
      <div className="rip-frame-top" />
      <div className="rip-frame-bottom" />
      <div className="ember-container">
        {Array.from({ length: 15 }).map((_, i) => (
          <div key={i} className="ember-particle" style={{ left: `${Math.random()*100}%`, bottom: `${Math.random()*30}%`, animationDelay: `${Math.random()*6}s`, animationDuration: `${4+Math.random()*4}s` }} />
        ))}
      </div>
      <div className="parallax-banner" ref={parallaxRef} style={guild.banner_url ? { backgroundImage: `url(${guild.banner_url})` } : undefined} />
      <div className={`guild-content ${ripped ? 'visible' : ''}`}>
        <div className="guild-header">
          <h1 className="guild-name">⚔️ {guild.name}</h1>
          {guild.tagline && <p className="guild-tagline">"{guild.tagline}"</p>}
        </div>

        <div className="guild-section">
          <h3>🏆 Stats</h3>
          <div className="stats-row">
            <div className="stat-block"><span className="stat-num">{guild.stats?.combats || 0}</span><span className="stat-label">Combats</span></div>
            <div className="stat-block"><span className="stat-num">{guild.stats?.enemies_slain || 0}</span><span className="stat-label">Slain</span></div>
            <div className="stat-block"><span className="stat-num">{guild.stats?.spells_cast || 0}</span><span className="stat-label">Spells</span></div>
            <div className="stat-block"><span className="stat-num">{guild.stats?.damage_dealt || 0}</span><span className="stat-label">Damage</span></div>
            <div className="stat-block"><span className="stat-num">{guild.stats?.deaths || 0}</span><span className="stat-label">Deaths</span></div>
            <div className="stat-block"><span className="stat-num">{guild.stats?.xp_earned || 0}</span><span className="stat-label">XP</span></div>
          </div>
        </div>

        {guild.achievements && guild.achievements.length > 0 && (
          <div className="guild-section">
            <h3>🏆 Achievements</h3>
            <div className="achievement-grid">
              {guild.achievements.map(id => <AchievementBadge key={id} id={id} />)}
            </div>
          </div>
        )}

        <div className="guild-section">
          <h3>👥 Roster ({guild.member_count})</h3>
          {guild.roster.map((c, i) => (
            <div key={i} className="roster-item">
              <span className="roster-name">{c.name}</span>
              <span className="roster-info">Lvl {c.level} {c.race} {c.class}</span>
            </div>
          ))}
        </div>

        {guild.schedule && (
          <div className="guild-section">
            <h3>📅 Schedule</h3>
            <p>{guild.schedule}</p>
          </div>
        )}

        {guild.style_tags && guild.style_tags.length > 0 && (
          <div className="guild-section">
            <h3>🎭 Style</h3>
            <div className="guild-tags">
              {guild.style_tags.map(tag => <span key={tag} className="guild-tag">{tag}</span>)}
            </div>
          </div>
        )}

        {guild.looking_for && (
          <div className="guild-section">
            <h3>📍 Looking For</h3>
            <p>{guild.looking_for}</p>
          </div>
        )}

        {guild.description && (
          <div className="guild-section">
            <h3>📖 About</h3>
            <p className="guild-description">{guild.description}</p>
          </div>
        )}

        <div className="guild-footer">
          <span>Powered by <a href="https://dndlorewalker.com">Lorewalker</a> 🌐</span>
        </div>
      </div>
    </div>
  );
}
